module.exports = __webpack_public_path__ + "img/0Q3A3375_L_WoodMatted_MockedUp.8abed49c.jpg";